// Constants
import { GIL_API_CHANNEL } from 'constants/api.constants';
// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const CANCEL_ONBOARDING_ENDPOINT_CONFIGURATION = {
  endpoint: 'gil-api-mng-amz-ldg/v1/checkout/orders/:checkoutId/cancel',
  pathParams: {
    checkoutId: getCheckoutIdFromUrl(),
  },
  ...GIL_API_CHANNEL,
};

export { CANCEL_ONBOARDING_ENDPOINT_CONFIGURATION };
